export enum ProductCostValueType {
  points = 'points',
  dotz = 'dotz',
}

export namespace ProductCostValueType {
  export const translateType = (type: string): string => {
    switch (type) {
      case ProductCostValueType.points:
        return "Pontos";
      case ProductCostValueType.dotz:
        return "Dotz";
      default:
        return "";
    }
  };

  export const productCostValueTypeChoices = Object.values(ProductCostValueType)
    .filter(x => typeof x === "string")
    .map((type) => ({
      id: type,
      name: ProductCostValueType.translateType(type),
    }));
}
